<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Part-Title-1" style="text-align:center;">CONTENTS</p>
<p class="toc1"><a href="#/Fussell_Muscle_4P_MD6">THE INTRODUCTION</a></p>
<p class="toc2"><a href="#/Fussell_Muscle_4P_MD7">1. The Genesis</a></p>
<p class="toc1"><a href="#/Fussell_Muscle_4P_MD8">2. The Y</a></p>
<p class="toc1"><span href="#/Fussell_Muscle_4P_MD9" title="Link target outside of Sample">3. The Walk</span></p>
<p class="toc1"><span href="#/Fussell_Muscle_4P_MD10" title="Link target outside of Sample">4. The Metamorphosis</span></p>
<p class="toc1"><span href="#/Fussell_Muscle_4P_MD11" title="Link target outside of Sample">5. The Bunker</span></p>
<p class="toc1"><span href="#/Fussell_Muscle_4P_MD12" title="Link target outside of Sample">6. The Move</span></p>
<p class="toc1"><span href="#/Fussell_Muscle_4P_MD13" title="Link target outside of Sample">7. The Juice</span></p>
<p class="toc1"><span href="#/Fussell_Muscle_4P_MD14" title="Link target outside of Sample">8. The Digs</span></p>
<p class="toc1"><span href="#/Fussell_Muscle_4P_MD15" title="Link target outside of Sample">9. The Vocational Opportunities</span></p>
<p class="toc1"><span href="#/Fussell_Muscle_4P_MD16" title="Link target outside of Sample">10. The Ninth Annual Rose City Bench-Press Extravaganza</span></p>
<p class="toc1"><span href="#/Fussell_Muscle_4P_MD17" title="Link target outside of Sample">11. The Blitz</span></p>
<p class="toc1"><span href="#/Fussell_Muscle_4P_MD18" title="Link target outside of Sample">12. The San Gabriel Valley</span></p>
<p class="toc1"><span href="#/Fussell_Muscle_4P_MD19" title="Link target outside of Sample">13. The Diet</span></p>
<p class="toc1"><span href="#/Fussell_Muscle_4P_MD20" title="Link target outside of Sample">14. The Golden Valley</span></p>
<p class="toc1"><span href="#/Fussell_Muscle_4P_MD21" title="Link target outside of Sample">15. The Aftermath</span></p>
<p class="toc2"><span href="#/Fussell_Muscle_4P_MD22" title="Link target outside of Sample">THE IMAGE GALLERY</span></p>
<p class="toc2"><span href="#/Fussell_Muscle_4P_MD23" title="Link target outside of Sample">ABOUT THE AUTHOR</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Fussell_Muscle_4P_MD3.vue?2921167e